(function () {
    var host = window.location.hostname;
    var domainConfigMap = {
        "gizzmo.hr": {
            cdnSrc: "https://user-cart.gizzmo.hr/uniclick.js?attribution=lastpaid&cookiedomain=gizzmo.hr&cookieduration=90&defaultcampaignid=69bbe64c4ee5776f8595db9a&regviewonce=false",
            localSrc: "/assets/gizzmo/js/ext/redtrack/uniclick.js"
        },
        "gizzmo.hu": {
            cdnSrc: "https://user-cart.gizzmo.hu/uniclick.js?attribution=lastpaid&cookiedomain=gizzmo.hu&cookieduration=90&defaultcampaignid=69bbe64ec99ed3fb74e1fb95&regviewonce=false",
            localSrc: "/assets/gizzmo/js/ext/redtrack/uniclick.js"
        },
        "reswag.cz": {
            cdnSrc: "https://user-cart.reswag.cz/uniclick.js?attribution=lastpaid&cookiedomain=reswag.cz&cookieduration=90&defaultcampaignid=69bbe6502c7c7545c6551555&regviewonce=false",
            localSrc: "/assets/gizzmo/js/ext/redtrack/uniclick.js"
        },
        "default": {
            cdnSrc: "https://user-cart.gizzmo.si/uniclick.js?attribution=lastpaid&cookiedomain=gizzmo.si&cookieduration=90&defaultcampaignid=69bbe6302c7c7545c6550b88&regviewonce=false",
            localSrc: "/assets/gizzmo/js/ext/redtrack/uniclick.js"
        }
    };
    function resolveDomainConfig(currentHost) {
        var keys = Object.keys(domainConfigMap);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key === "default") {
                continue;
            }
            if (currentHost === key || currentHost.slice(-(key.length + 1)) === "." + key) {
                return domainConfigMap[key];
            }
        }
        return domainConfigMap["default"];
    }
    var domainConfig = resolveDomainConfig(host);
    var cdnSrc = domainConfig.cdnSrc;
    var localSrc = domainConfig.localSrc;

    var loaded = false;
    function loadLocal() {
        if (loaded) return;
        loaded = true;
        var local = document.createElement('script');
        local.src = localSrc;
        local.async = true;
        document.head.appendChild(local);
    }
    var s = document.createElement('script');
    s.src = cdnSrc;
    s.async = true;
    s.onload = function () {
        loaded = true;
    };
    s.onerror = function () {
        loadLocal();
    };
    document.head.appendChild(s);

    setTimeout(function () {
        if (!loaded){
            loadLocal();
        }
    }, 3000); // 3 seconds timeout
})();